import styles from "../WorkoutAdminModal.module.css";
import Badge from "./Badge";

// Uma linha de exercício dentro de "Itens adicionados" — usada tanto pra
// itens avulsos quanto pra itens dentro de um bloco de bi-set/superset
// (ver buildItemBlocks). showMoveButtons controla se os botões ↑/↓
// individuais aparecem: dentro de um grupo eles ficam ocultos (o grupo
// inteiro se move de uma vez, via botão no wrapper — handleMoveBlock),
// pra nunca intercalar um item de fora no meio do grupo.
export default function PlanItemRow({
  item,
  canManage,
  selectMode,
  isSelected,
  onToggleSelect,
  onEdit,
  onDelete,
  onMoveUp,
  onMoveDown,
  moveUpDisabled,
  moveDownDisabled,
  showMoveButtons,
  saving,
}) {
  // Em modo de seleção, a linha inteira vira o alvo de toque (não só o
  // checkbox de 18px) — achado #2 da auditoria UX: no mobile, marcar vários
  // exercícios exigindo acertar um alvo tão pequeno é ruim (Fitts's Law).
  // Ignora clique vindo do próprio checkbox pra não alternar 2x (o onChange
  // dele já chama onToggleSelect).
  const handleRowClick = (e) => {
    if (!selectMode) return;
    if (e.target.tagName === "INPUT") return;
    onToggleSelect(item.id);
  };

  return (
    <div
      className={`${styles.planItemRow}${selectMode ? ` ${styles.planItemRowSelectable}` : ""}${isSelected ? ` ${styles.planItemRowSelected}` : ""}`}
      onClick={handleRowClick}
    >
      <div className={styles.planItemRowLeft}>
        {selectMode && (
          <input
            type="checkbox"
            className={styles.studentCheckbox}
            checked={isSelected}
            onChange={() => onToggleSelect(item.id)}
            aria-label={`Selecionar ${item.exercise_item?.name || "exercício"}`}
          />
        )}
        <div className={styles.planItemRowMain}>
          <div className={styles.planItemTitle}>
            {item.exercise_item?.name || `Item ${item.id}`}
          </div>

          <div className={styles.planItemMeta}>
            {item.category?.name && <Badge tone="default">{item.category.name}</Badge>}

            <span>
              {[
                item.sets_planned ? `${item.sets_planned}x` : null,
                item.reps_planned || null,
                item.weight_planned ? `${item.weight_planned}kg` : null,
                item.duration_planned ? `${item.duration_planned}min` : null,
                item.rest_seconds ? `${item.rest_seconds}s descanso` : null,
              ]
                .filter(Boolean)
                .join(" • ")}
            </span>
          </div>
        </div>
      </div>

      {canManage && !selectMode && (
        <div className={styles.planItemRowActions}>
          {showMoveButtons && (
            <>
              <button
                type="button"
                className={`${styles.wamBtn} ${styles.smallGhost}`}
                title="Mover para cima"
                onClick={onMoveUp}
                disabled={saving || moveUpDisabled}
              >
                ↑
              </button>
              <button
                type="button"
                className={`${styles.wamBtn} ${styles.smallGhost}`}
                title="Mover para baixo"
                onClick={onMoveDown}
                disabled={saving || moveDownDisabled}
              >
                ↓
              </button>
            </>
          )}
          <button type="button" className={`${styles.wamBtn} ${styles.smallGhost}`} onClick={onEdit}>
            Editar
          </button>
          <button type="button" className={`${styles.wamBtn} ${styles.smallDanger}`} onClick={onDelete}>
            Excluir
          </button>
        </div>
      )}
    </div>
  );
}
